import { openUrlInNewTabWhileTwilioCallIsActive } from './twilio-common.js';

(function() {
  let initialized = false;

  function listenInit() {
    TourlaneFlex.addEventListener('init', function(_payload) {
      initialized = true;
      $('#loader-icon').removeClass('fa-spin');
      $('#waiting-message').hide();

      const form = document.getElementById('call-form');
      $(form).show();
      document.addEventListener('submit', (e) => {
        if (form === e.target) {
          handleFormSubmit(form);
        }

        e.preventDefault();
      });
    });
  }

  function listenReservationAccepted() {
    TourlaneFlex.addEventListener('reservationAccepted', function(reservation) {
      const url = reservation.taskAttributes?.call_web_context?.url

      if (url) {
        openUrlInNewTabWhileTwilioCallIsActive(url)
      }
    });
  }

  function setupPopupOpenButton() {
    document.getElementById('popup-opener').addEventListener('click', function(e) {
      openUrlInNewTabWhileTwilioCallIsActive("/qualification/presales/exit")
    });
  }

  async function handleFormSubmit(form) {
    try {
      const response = await fetch(form.action, { method: form.method, body: new FormData(form) });
      if (response.ok) {
        $(form).hide();
        $('#form-success-message').show();
      } else {
        if (response.status === 400) {
          $('#form-invalid-phone-message').show();
        } else {
          $('#form-error-message').show();
        }
      }
    } catch (error) {
      $('#form-error-message').show();
    }
  }

  function startTimeout() {
    setTimeout(() => {
      if (!initialized) {
        $('#loader-icon').removeClass('fa-spin');
        $('#timeout-message').show();
        $('#waiting-message').hide();
        Sentry.captureMessage('[Auto Dialer Test] Timeout waiting for Twilio to initialize.')
      }
    }, 60000);
  }

  window.addEventListener('DOMContentLoaded', () => {
    const isAutoDialerPage = document.querySelector('meta[name="current_page"]')?.content === 'auto_dialer_test'
    if (!isAutoDialerPage) {
      return
    }

    startTimeout();
    TourlaneSuite.showFlexIframe();
    setupPopupOpenButton();
    listenReservationAccepted();
    listenInit();
  });
})();
